import type { MarqueeTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const marqueeDark: MarqueeTheme = {
  name: 'Marquee',
  common: commonDark,
  self
}

export default marqueeDark
